__turbopack_context__.v({
  "buttonsContainer": "Form-module___xQ2ka__buttonsContainer",
  "clearButton": "Form-module___xQ2ka__clearButton",
  "errorMessage": "Form-module___xQ2ka__errorMessage",
  "eyeButton": "Form-module___xQ2ka__eyeButton",
  "form": "Form-module___xQ2ka__form",
  "inputRow": "Form-module___xQ2ka__inputRow",
  "isVisible": "Form-module___xQ2ka__isVisible",
  "submitButtonDisabled": "Form-module___xQ2ka__submitButtonDisabled",
});
